import { Action } from 'redux'
import { NotificationActions } from '../../reducers/userAccount/actionNames'

const sendErrorNotificationMessage = (
  recipient: string,
  subject: string,
  body: string,
  notificationId: string,
): ISendNotificationErrorMMessage => ({
  body,
  notificationId,
  recipient,
  subject,
  type: NotificationActions.SendError,
})

export interface ISendNotificationErrorMMessage
  extends Action<NotificationActions.SendError> {
  recipient: string
  subject: string
  body: string
  notificationId: string
}

export default sendErrorNotificationMessage
